"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var radioFilter = function radioFilter(data) {
  return data.filter(function (res) {
    return res.type === "radio";
  });
};

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    label1: {
      textAlign: "center",
      marginBottom: "10%"
    },
    label2: {
      textAlign: "center",
      marginTop: "10%",
      marginBottom: "10%"
    }
  };
});

var FormItemsDependency = function FormItemsDependency(_ref) {
  var objectsForm = _ref.objectsForm,
      properties = _ref.properties,
      handlePropertyChange = _ref.handlePropertyChange;
  var classes = useStyles();

  var handleSelectDisableDependency = function handleSelectDisableDependency(e) {
    return handlePropertyChange(properties, "disableDependency", e.target.value);
  };

  return /*#__PURE__*/_react.default.createElement("form", {
    style: {
      marginBottom: "1rem"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: "Dependiente de",
    "aria-label": "value",
    placement: "top"
  }, /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/_react.default.createElement(_core.RadioGroup, {
    "aria-label": "disableDependency",
    name: "disableDependency",
    value: properties.disableDependency,
    onChange: handleSelectDisableDependency
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.label1,
    color: "textSecondary",
    display: "block",
    variant: "caption"
  }, "Este valor define si el campo de texto va a ocultarse"), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: /*#__PURE__*/_react.default.createElement("span", {
      style: {
        whiteSpace: "pre-line"
      }
    }, "En caso de ser varios valores, ingreselos separados por comas , Ej: \n\n                            Valor1,Valor2,Valor3..."),
    "aria-label": "typeSelect",
    placement: "left-start"
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    name: "disableDependencyExpectedValue",
    label: "Valor esperado",
    placeholder: "Ej: si",
    value: properties.disableDependencyExpectedValue || "",
    onChange: function onChange(e) {
      return handlePropertyChange(properties, "disableDependencyExpectedValue", e.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.label2,
    color: "textSecondary",
    display: "block",
    variant: "caption"
  }, "Elige la pregunta que tendra el valor esperado"), radioFilter(objectsForm) //.filter((res) => !res.validations.allowNull) //si se le permite null entonces no debe tener dependencias
  .map(function (acc, key) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
      key: key,
      value: acc.i,
      control: /*#__PURE__*/_react.default.createElement(_core.Radio, {
        color: "primary"
      }),
      label: acc.label
    }), /*#__PURE__*/_react.default.createElement(_core.Divider, null));
  }))), /*#__PURE__*/_react.default.createElement(_core.Button, {
    disabled: !properties.disableDependency,
    size: "small",
    onClick: function onClick(e) {
      e.preventDefault();
      handlePropertyChange(properties, "disableDependency", null);
    }
  }, "Reset dependencias")))));
};

var _default = FormItemsDependency;
exports.default = _default;